<template>
    <div class="base">
        <nav-header></nav-header>
        <router-view></router-view>

    </div>
</template>

<script>
import navHeader from '../components/NavHeader'
export default {
    components: {
        navHeader
    },
    data () {
        return {
            
        }
    }
}
</script>

<style lang="less" scoped>
    .base {
        height: 100%;
    }
</style>